<ng-container *ngIf="item$ | async as item">
    <ng-container *ngIf="hasDropMenuItems(item); then linkWithDropmenuTemplate; else defaultLinkTemplate"></ng-container>

    <ng-template #defaultLinkTemplate>
        <a [shNavigationLink]="item.navigationLink" [ngClass]="{ '-sh-active': isActive$ | async }" class="sh-compact-navigation__link">
            <svg sh-icon *ngIf="item.icon" [name]="item.icon" class="sh-compact-navigation__link__icon" aria-hidden="true"></svg>
            <span class="sh-compact-navigation__link__label" [title]="item.label">{{ item.label }}</span>
            <sh-badge *ngIf="item.badge" class="sh-compact-navigation__link__badge" [badge]="item.badge"></sh-badge>
        </a>
    </ng-template>

    <ng-template #linkWithDropmenuTemplate>
        <div
            class="sh-compact-navigation__dropmenu"
            (mouseenter)="openSubMenu()"
            (mouseleave)="closeSubMenu()"
            (click)="openSubMenu()"
            (keyup.enter)="openSubMenu()"
            [attr.open]="item.isOpen ? 'true' : null"
            #detailsElement
        >
            <summary class="sh-compact-navigation__dropmenu__header" [ngClass]="{ '-sh-active': isActive$ | async }">
                <svg sh-icon *ngIf="item.icon" [name]="item.icon" class="sh-compact-navigation__link__icon" aria-hidden="true"></svg>
                <span class="sh-compact-navigation__link__label" [title]="item.label">{{ item.label }}</span>
                <sh-badge *ngIf="item.badge" class="sh-compact-navigation__link__badge" [badge]="item.badge"></sh-badge>
            </summary>

            <div class="sh-compact-navigation__dropmenu__list-wrapper" [ngClass]="{ '-sh-open-above': openDropmenuAbove }">
                <ul class="sh-compact-navigation__dropmenu__list">
                    <li
                        *ngFor="let dropmenuItem of item.dropmenuItems"
                        class="sh-compact-navigation__dropmenu__list__item"
                        [title]="dropmenuItem.label"
                        routerLinkActive="-sh-active"
                        (mouseenter)="onHover($event, dropmenuItem)"
                    >
                        <a [shNavigationLink]="dropmenuItem.navigationLink" class="sh-compact-navigation__dropmenu__link sh-icon-link" (click)="closeSubMenu()">
                            <span>{{ dropmenuItem.label }}</span>
                            <sh-badge *ngIf="item.badge" class="sh-icon-link__icon" [badge]="item.badge"></sh-badge>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </ng-template>
</ng-container>
